import axios from 'axios';
import { get } from 'lodash';
import history from 'config/history';
import { getToken, clearToken } from './Auth';

export default ({ bypassAuthCheck = false } = {}) => {
  const token = getToken();
  const headers =
    token && !bypassAuthCheck ? { Authorization: `JWT ${token}` } : {};
  const params = {
    baseURL: '/api',
    headers,
  };
  const client = axios.create(params);
  client.defaults.headers.get['Pragma'] = 'no-cache';
  if (!bypassAuthCheck) {
    client.interceptors.response.use(null, err => {
      if (get(err, 'response.status') === 401) {
        err.handled = true;
        clearToken();
        history.push('/login');
      }
      throw err;
    });
  }

  return client;
};



// WEBPACK FOOTER //
// ./src/services/ApiClient.js